var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1921 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #2fa770;\n      }\n\n      .st1 {\n        fill: #1c452b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,210.5h-76.5v-77.4h-37l-10.8,30.6c-2.5,7.2-12.7,7.2-15.2,0l-10.8-30.6h-37v77.4h-77.2v37l30.6,10.8c7.2,2.5,7.2,12.7,0,15.2l-30.6,10.8v37h77.2v77.2h37l10.8-30.6c2.5-7.2,12.7-7.2,15.2,0l10.8,30.6h37v-77.2h76.5v-37l-30.6-10.8c-7.2-2.5-7.2-12.7,0-15.2l30.6-10.8v-37ZM295.1,162.8h5.5v47.7h-22.2l16.7-47.7ZM300.6,298.6v2h-69.3v-69.3h69.3v67.3ZM231.3,162.8h5.4l16.7,47.7h-22.1v-47.7ZM163,236.8v-5.5h47.5v22.1l-47.5-16.6ZM163,300.6v-5.4l47.5-16.6v22h-47.5ZM236.8,368.9h-5.5v-47.5h22.1l-16.6,47.5ZM300.6,368.9h-5.4l-16.6-47.5h22v47.5ZM368.2,295.1v5.5h-46.8v-21.9l46.8,16.4ZM368.2,236.7l-46.8,16.4v-21.8h46.8v5.4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.6,143.2h66l53.2,164.6c1.5,4.6,8.1,4.7,9.6,0l53.5-164.6h66v242h-44.5v-174.1l-56.6,174.1h-48.3l-56.7-175.1v175.1h-42.3v-242Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M761.7,297.3c0-55.4,39.3-91.3,90.5-91.3s86,31.1,86,87.9v11.7h-126.7c-1.7,0-3.1,1.5-2.8,3.2,3.9,26.9,21.4,40,42.8,40s34.6-8.6,43.6-26.4l39.8,14.8c-14.5,31.6-43.9,51.2-83.4,51.2s-89.9-35.9-89.9-91.1ZM889.8,276.4c-4.6-20.5-17.9-30.8-37.5-30.8s-34.9,10.1-41.3,30.8h78.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M954.4,297.3c0-55.4,37.9-91.3,81.6-91.3s38.5,8.5,51.5,23.2v-85.9h46.3v242h-40.4l-1.3-9c-.9-6.3-6.5-8.5-10.7-4.8-12.3,10.9-27.9,17.1-45.4,17.1-43.7,0-81.6-35.9-81.6-91.1ZM1044.1,347.5c24.1,0,43.4-17.3,43.4-50.2s-19.3-50.4-43.4-50.4-43.6,17.4-43.6,50.4,19.3,50.2,43.6,50.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1155.7,143.2h46.8v96.9h109.2v-96.9h46.8v242h-46.8v-103.3h-109.2v103.3h-46.8v-242Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1376,340.7c0-32.4,25.2-44.2,59.7-53.3l50.2-13.2c-2.8-18.9-15.4-28.5-36.4-28.5s-34,9.1-45,27.4l-32.2-19.9c17.1-29.5,45-47.1,82.6-47.1s77.9,27.7,77.9,73.4v105.8h-40.1l-1.8-12.4c-.5-4.4-5.1-6.5-8.1-3.5-12.2,12-29.7,19.1-51.7,19.1-31.5,0-54.9-16.6-54.9-47.8ZM1443.5,354.9c21.1,0,43.1-12.9,43.1-40.3v-12.1l-39.8,11.1c-15.8,4.4-24.5,11.1-24.5,22.5s8.8,18.8,21.3,18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1598,310.7c0,22.3,15.1,38,37.7,38s37.1-15.7,37.1-37.8v-101.6h46.2v175.9h-42.3l-1.8-13.6c-.4-3.5-4-4.8-6.2-2.4-11.1,12-26.7,19.3-47.1,19.3-41.6,0-69.7-29.3-69.7-72.1v-107.1h46.2v101.4Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 1742.3,
    y: 143.2,
    width: 45.7,
    height: 241.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenlogo);
export default __webpack_public_path__ + "static/media/greenlogo.18225061301d37ac742f4bd09c468ade.svg";
export { ForwardRef as ReactComponent };